const e = [
  ["bold", "italic", "underline", "strike", "clean"],
  ["h1", "h2", "h3", "h4"],
  ["unorderedList", "orderedList"],
  ["link", "image", "video", "blockquote", "codeBlock"],
  ["alignLeft", "alignCenter", "alignRight"],
  ["sup", "sub"]
];
export {
  e as DEFAULT_CONTROLS
};
